import { Modal } from "flowbite-react";
import FormCreateSubProduct from "../form/FormCreateSubProduct";

type Props = {
  onClose?: () => void
  onSave: (productId: string) => void
}

export default function ModalCreateSubProduct(props: Props) {

  const handleCloseModal = () => { props.onClose && props.onClose() }

  return (
    <Modal
      className='relative text-black'
      onClose={() => handleCloseModal()}
      show={true}
    >
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">{'Novo SubItem'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormCreateSubProduct onSubmit={handleCloseModal} />
      </Modal.Body>
    </Modal>
  )
}